import {
  Badge,
  Icon,
  SUPPORTED_ICON,
  Text,
  Box,
  Button,
} from '@marketmuse/components';

export function SubscriptionUpsellContent({
  disclaimer,
  ctaAttrs,
  handleBookDemo,
}: {
  disclaimer: string;
  ctaAttrs: Record<string, string>;
  handleBookDemo: () => void;
}) {
  return (
    <Box className={['flex', 'flex-col', 'max-w-2xl']}>
      <div>
        <Badge
          color="yellow"
          shade={'light'}
          size={'base'}
          as="span"
          className={['flex', 'gap-x-2', 'items-center', 'w-fit']}
        >
          <Icon
            name={SUPPORTED_ICON.warning_triangle}
            color="text-yellow-600"
          />
          <Text>{disclaimer}</Text>
        </Badge>
      </div>

      <Text as="h1" className={['text-2xl', 'font-bold', 'mt-4']}>
        Book a demo and discover Siteimprove
      </Text>

      <Text as="p" className={['mt-2', 'text-sm']}>
        MarketMuse was acquired by Siteimprove, providing a unified solution to
        help teams deliver content experiences that are accessible,
        AI-discoverable and high-performing.
      </Text>

      <Box className={['bg-gray-50', 'rounded-md', 'p-6', 'mt-4']}>
        <Text className={['font-bold', 'text-sm', 'block']}>
          Book a demo to learn how you can:
        </Text>

        <Box
          as="ul"
          className={['list-disc', 'pl-5', 'flex', 'flex-col', 'gap-1', 'mt-3']}
        >
          <li>
            <Text as="span" className={['text-sm']}>
              Boost visibility and authority so your content is found by both
              people and AI.
            </Text>
          </li>
          <li>
            <Text as="span" className={['text-sm']}>
              Drive performance by turning analytics into prioritized
              recommendations.
            </Text>
          </li>
          <li>
            <Text as="span" className={['text-sm']}>
              Reduce compliance risk by proactively identifying accessibility,
              link quality, and content governance issues.
            </Text>
          </li>
          <li>
            <Text as="span" className={['text-sm']}>
              Streamline workflows so your team spends less time toggling tools
              and more time delivering value.
            </Text>
          </li>
        </Box>

        <Button
          variant="blue400"
          className={['mt-4']}
          {...ctaAttrs}
          onClick={handleBookDemo}
        >
          Request a Siteimprove demo
        </Button>
      </Box>
    </Box>
  );
}
